import type { Config } from '@ms/yammer-libs-static-config';
import { getCurrentRedirectUri } from '@ms/yammer-web-authenticators';
import { insertSplash } from '@ms/yammer-web-support/dist/splash';

type DeepWritable<T> = {
  -readonly [K in keyof T]: T[K] extends infer U ? (U extends object ? DeepWritable<U> : U) : never;
};

// eslint-disable-next-line @typescript-eslint/no-require-imports
const config: DeepWritable<Config> = require(`./${process.env.YAMMER_ENV}.json`);

config.telemetry.gitRevision = process.env.GIT_REVISION as string;
config.adal.redirectUri = getCurrentRedirectUri(config.adal.validAuthRedirectUris, config.adal.redirectUri);
config.adal.resources.yammer = process.env.TEAMLABS_APP_ID
  ? `api://${process.env.TEAMLABS_APP_ID}`
  : config.adal.resources.yammer;
config.msal.redirectUri = getCurrentRedirectUri(config.msal.validAuthRedirectUris, config.msal.redirectUri);

insertSplash({
  target: document.getElementById('root'),
  shouldUseTeamsSpinner: true,
  shouldUseTransparentBackground: true,
});

window.__yammerconfig__ = config;
